export const getDevPosts = async () => {
   const url = `https://dev.to/api/articles/?username=jpuls`;

   var requestOptions = {
      method: "GET",
      redirect: "follow"
   };

   const data = fetch(url, requestOptions)
      .then((res) => res.json())
      .then((data) => data)
      .catch((e) => console.log(e));
   return await data;
};

export default getDevPosts;
